import React from "react";

const getIconClass = (key) => {
    switch (key) {
        case "TotalActiveLead":
            return "far fa-list-alt font-size-22";
        case "TotalAppointment":
            return "far fa-calendar-alt  font-size-24";
        case "TodaysTask":
            return "mdi mdi-book-clock-outline font-size-24";
        case "Todays Appointment":
            return "mdi mdi-calendar-clock font-size-24";
        case "PendingTask":
            return "mdi mdi-progress-clock font-size-24";
        case "HelpNeeded":
            return "mdi mdi-help-circle-outline font-size-24";
        case "AdditionalWork":
            return "mdi mdi-file-document-edit-outline font-size-24";
        case "Improvement":
            return "mdi mdi-inbox-arrow-up font-size-24";
        case "TodaysCall":
            return "mdi mdi-file-phone-outline font-size-24";
        case "TodaysLead":
            return "mdi mdi-format-list-checks font-size-24";
        case "TodaysFollowUp":
            return "fas fa-bullhorn fs-5";
        case "PendingLeaves":
            return "fas fa-hourglass-half fs-5";
        default:
            return "mdi mdi-message-text-clock-outline font-size-24";
    }
};

const IconComponent = ({ report }) => {
    const iconClass = getIconClass(report.Key);

    return <i className={iconClass}></i>;
};

export default IconComponent;
